import {Pipe, PipeTransform} from '@angular/core';
import {AdvancedFilterFieldTypesEnum} from '../components/advance-filter';

@Pipe({
  name: 'filterGroupName'
})
export class FilterGroupNamePipe implements PipeTransform {

  transform(value: string): string {
    switch (value){
        case AdvancedFilterFieldTypesEnum.general_field:
            return 'General';
        case AdvancedFilterFieldTypesEnum.document_field:
            return 'Document fields';
        case AdvancedFilterFieldTypesEnum.organization_field:
            return 'Organization Data';
        case AdvancedFilterFieldTypesEnum.person_field:
            return 'People data';
    }
  }

}
